import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function mrb(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@mrb/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@mrb/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@mrb/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@mrb/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@mrb/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@mrb/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}